import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <CarouselSection />
        <CardsSection />
        <AboutSection />
        <MediaSection />
        <UpdatesSection />
        <AppSection />
        <FaqSection />
        <CommentsSection />
        <FeaturesSection />
        <ContactSection />
        <RankingSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}